import { RouteRecordRaw } from 'vue-router';

const schedulerRoutes: RouteRecordRaw[] = [
	{
		path: '/konto/terminarz',
		name: 'SchedulerWrapper',
		component: () => import('@customer/scheduler/SchedulerWrapper.vue'),
		redirect: { name: 'SchedulerPage' },
		children: [
			{
				path: '',
				name: 'SchedulerPage',
				component: () => import('@customer/scheduler/SchedulerPage.vue'),
			},
			{
				path: 'klienci',
				name: 'SchedulerClientsList',
				component: () => import('@customer/scheduler/clients/SchedulerClientsList.vue'),
			},
			{
				path: 'klienci/nowy',
				name: 'SchedulerClientsAdd',
				component: () => import('@customer/scheduler/clients/SchedulerClientsForm.vue'),
			},
			{
				path: 'klienci/:id',
				name: 'SchedulerClientsEdit',
				component: () => import('@customer/scheduler/clients/SchedulerClientsForm.vue'),
				props: true,
			},
			{
				path: ':termId',
				name: 'SchedulerDetails',
				component: () => import('@customer/scheduler/details/SchedulerDetails.vue'),
				props: true,
			},
		],
	},
];

export default schedulerRoutes;
